<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("CASH_REGISTERS.ADD_CASH_REGISTER") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <cash-register-form
              :loading="loading"
              :cashRegisterData="cashRegister"
              :formErrors="formErrors"
              @cashRegisterSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultCashRegister from "./defaultCashRegister";
import CashRegisterForm from "./partials/CashRegisterForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    CashRegisterForm,
  },

  mixins: [alertLeave],

  data() {
    const cashRegister = cloneDeep(defaultCashRegister);
    return {
      cashRegister: cashRegister,
      formErrors: null,
      loading: false,
    };
  },

  methods: {
    goBack() {
      this.$router.push({ name: "List CashRegisters" });
    },

    viewCashRegister(cashRegister) {
      this.alertLeave = false;
      this.$router.push({
        name: "View CashRegister",
        params: { id: cashRegister.id },
      });
    },

    async handleSubmit(cashRegister) {
      this.loading = true;
      const cashRegisterData = cloneDeep(cashRegister);
      if (cashRegisterData.serviceCenter) {
        if (!cashRegisterData.serviceCenter.id) {
          delete cashRegisterData.serviceCenter;
        }
      }
      if (cashRegisterData.establishment) {
        if (!cashRegisterData.establishment.id) {
          delete cashRegisterData.establishment;
        }
      }
      if (cashRegisterData.cafeteria) {
        if (!cashRegisterData.cafeteria.id) {
          delete cashRegisterData.cafeteria;
        }
      }
      if (cashRegisterData.warehouse) {
        if (!cashRegisterData.warehouse.id) {
          delete cashRegisterData.warehouse;
        }
      }
      try {
        await this.$store.dispatch("cashRegisters/add", cashRegisterData);
        this.$notify({
          type: "success",
          message: this.$t("CASH_REGISTERS.CASH_REGISTER_ADDED"),
        });
        const cashRegister = await this.$store.getters[
          "cashRegisters/cashRegister"
        ];
        this.viewCashRegister(cashRegister);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        const cashRegister = await this.$store.getters[
          "cashRegisters/cashRegister"
        ];
        if (cashRegister.id) {
          await this.$store.dispatch(
            "cashRegisters/destroy",
            cashRegister.id
          );
        }
        this.loading = false;
      }
    },
  },
};
</script>

